const getStyles = () => {
  return {
    section: {
      padding: '80px 0',
      background:
        'linear-gradient(135deg, rgba(55, 170, 237, 0.05) 0%, rgba(55, 167, 212, 0.05) 100%)',
      '@media (max-width: 768px)': {
        padding: '60px 0'
      }
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px'
    },
    title: {
      fontWeight: '700',
      fontSize: '48px',
      lineHeight: '1.2',
      textAlign: 'center',
      marginBottom: '16px',
      color: '#000000',
      '@media (max-width: 768px)': {
        fontSize: '36px'
      }
    },
    subtitle: {
      fontSize: '20px',
      textAlign: 'center',
      marginBottom: '64px',
      color: 'rgba(0,0,0,0.7)'
    },
    timelineContainer: {
      maxWidth: '1000px',
      margin: '0 auto',
      position: 'relative'
    },
    timelineLine: {
      position: 'absolute',
      left: '50%',
      top: '0',
      bottom: '0',
      width: '2px',
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      transform: 'translateX(-50%)',
      '@media (max-width: 768px)': {
        display: 'none'
      }
    },
    phaseContainer: {
      marginBottom: '64px',
      position: 'relative'
    },
    phaseRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '32px',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        gap: '16px'
      }
    },
    phaseRowReversed: {
      flexDirection: 'row-reverse',
      '@media (max-width: 768px)': {
        flexDirection: 'column'
      }
    },
    phaseContent: {
      flex: '1',
      '@media (max-width: 768px)': {
        textAlign: 'center'
      }
    },
    phaseContentRight: {
      textAlign: 'right',
      '@media (max-width: 768px)': {
        textAlign: 'center'
      }
    },
    phaseContentLeft: {
      textAlign: 'left',
      '@media (max-width: 768px)': {
        textAlign: 'center'
      }
    },
    phaseBadge: {
      display: 'inline-block',
      padding: '8px 24px',
      borderRadius: '25px',
      fontWeight: '700',
      fontSize: '16px',
      marginBottom: '16px'
    },
    phaseBadgePrimary: {
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      color: '#FFFFFF'
    },
    phaseBadgeGold: {
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      color: '#000000'
    },
    phaseTitle: {
      fontSize: '32px',
      fontWeight: '700',
      marginBottom: '8px',
      color: '#000000'
    },
    phaseDuration: {
      fontSize: '20px',
      color: 'rgba(0,0,0,0.6)',
      marginBottom: '16px'
    },
    phaseQuote: {
      fontSize: '18px',
      fontStyle: 'italic',
      color: 'rgba(0,0,0,0.7)'
    },
    timelineDot: {
      width: '64px',
      height: '64px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      zIndex: '10',
      flexShrink: 0,
      '@media (max-width: 768px)': {
        display: 'none'
      }
    },
    timelineDotPrimary: {
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)'
    },
    timelineDotGold: {
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)'
    },
    timelineIcon: {
      width: '32px',
      height: '32px',
      color: '#FFFFFF'
    },
    cardContainerRight: {
      flex: '1',
      display: 'flex',
      justifyContent: 'flex-start'
    },
    cardContainerLeft: {
      flex: '1',
      display: 'flex',
      justifyContent: 'flex-end'
    },
    phaseCard: {
      width: '100%',
      maxWidth: '500px',
      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
        transform: 'translateY(-4px)'
      }
    },
    phaseCardGold: {
      border: '1px solid rgba(212,175,55,0.2)'
    },
    cardContent: {
      padding: '24px'
    },
    cardTitle: {
      fontSize: '18px',
      fontWeight: '600',
      marginBottom: '16px',
      color: '#000000'
    },
    list: {
      padding: '0',
      margin: '0',
      listStyle: 'none'
    },
    listItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '8px',
      marginBottom: '12px',
      fontSize: '16px',
      lineHeight: '1.5'
    },
    listIcon: {
      width: '20px',
      height: '20px',
      color: '#4f46e5',
      marginTop: '2px',
      flexShrink: '0'
    },
    listIconGold: {
      color: '#38bdf8'
    },
    outcomeSection: {
      marginTop: '24px',
      paddingTop: '24px',
      borderTop: '1px solid rgba(0,0,0,0.1)'
    },
    outcomeTitle: {
      fontWeight: '700',
      fontSize: '16px',
      marginBottom: '12px',
      color: '#4f46e5'
    },
    outcomeTitleGold: {
      color: '#38bdf8'
    },
    starList: {
      padding: '0',
      margin: '0',
      listStyle: 'none'
    },
    starItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '8px',
      fontSize: '14px'
    },
    starIcon: {
      width: '16px',
      height: '16px',
      color: '#4f46e5'
    }
  };
};

export default getStyles;
